
























export default {
  name: 'toggle',
  props: {
    options: {
      type: Array, // { id: string, label: string }[]
      required: true
    },
    value: {
      type: String,
      required: true
    },
    label: String,
    disabled: Boolean
  },
  computed: {
    optionWidthPct: function (): number {
      return (100 / this.options.length);
    },
    selectedOptionIndex: function (): number {
      return this.options.findIndex((option) => (option.id === this.value));
    }
  }
};

